import { createFieldset } from './fieldset';

export default {
  title: 'Add Business',
  elements: [
    {
      type: 'createForm',
      config: {
        actions: {
          save: {
            endpoint: 'businesses',
            method: 'POST'
          }
        },
        fieldsets: [createFieldset]
      }
    }
  ]
};
